import { Logger } from '../share/logger';

declare const wx;
declare const my;

export function miniPlatform() {
  if (typeof wx !== 'undefined' && wx.getSystemInfo) {
    return wx;
  } else if (typeof my !== 'undefined' && my.getSystemInfo) {
    return my;
  }
  return undefined;
}

export function getMiniSubType() {
  if (isWx()) {
    return 'wxMini';
  } else if (isMy()) {
    return 'myMini';
  }
  return undefined;
}

export function isWx(): boolean {
  const platform = miniPlatform();
  return typeof wx !== 'undefined' && platform == wx;
}

export function isMy(): boolean {
  const platform = miniPlatform();
  return typeof my !== 'undefined' && platform == my;
}

/**
 * 从路由路径中提取查询参数并转换为对象
 * @param originRoute 原始路由路径字符串
 * @returns 查询参数对象，如果没有查询参数则返回空对象
 */
export function getSearch2obj(originRoute: string) {
  try {
    const url = decodeURIComponent(originRoute);
    // 查找search起点的索引
    const searchIndex = url.indexOf('?');
    if (searchIndex === -1) {
      return;
    } else {
      const searchStr = url.substring(searchIndex + 1);
      const result = {};
      // 分割参数键值对（处理 & 分隔）
      searchStr.split('&').forEach((item) => {
        const [key, value] = item.split('=');
        if (key) {
          result[key] = value;
        }
      });
      return result;
    }
  } catch (error) {
    Logger.error('transform search string to object error', error);
  }
}
